import restClient from 'Shared/hooks/restClient'

const useEmailPreview = (dependencies = [], overrideCampaignId = null, overrideEmailBlastId = null, contentVariantId = null) => {
  const campaignId = useSel(s => overrideCampaignId || s.campaign.id)
  const emailBlastId = useSel(s => overrideEmailBlastId || s.campaign.emailBlast.id)

  const [loading, setLoading] = useState(true)
  const [html, setHtml] = useState('')
  const [subjectLine, setSubjectLine] = useState('')

  useEffect(() => {
    if (!campaignId || !emailBlastId) return

    setLoading(true)

    const controller = new AbortController()

    const previewPath = contentVariantId
      ? `/api/campaigns/${campaignId}/email_blasts/${emailBlastId}/preview?content_variant_id=${contentVariantId}`
      : `/api/campaigns/${campaignId}/email_blasts/${emailBlastId}/preview`

    restClient.get(previewPath, { signal: controller.signal })
    .then(({ data }) => {
      setHtml(data.html)
      setSubjectLine(data.subjectLine)
      setLoading(false)
    })
    .catch(error => {
      setLoading(false)
    })

    return () => controller.abort() // Actually cancels the in-flight request
  }, [...dependencies, campaignId, emailBlastId, contentVariantId])

  return [html, subjectLine, loading]
}

export default useEmailPreview
